export default {"src":"/_next/static/media/KeyboardArrowLeft.cd09de11.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};